import { Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import NotificationsBoxHeader from './NotificationsBoxHeader';
import NotificationItem from './NotificationItem';
import EmptyNotifications from './EmptyNotifications';
import { useState } from 'react';
import { getNotifications } from 'state/reducers/notifications.reducer';
import { updateNotificationsByCompanyId } from 'services/notifications.service';

export default function NotificationsBox({ handleClose, unreadAmount }) {
	const dispatch = useAppDispatch();
	const currentNotifications = useAppSelector(getNotifications);
	const [notifications, setNotifications] = useState(currentNotifications);

	const handleMarkAsRead = async () => {
		const readNotifications: [{ [key: string]: number | boolean }] | any[] = [];
		notifications?.forEach((notification) => {
			readNotifications.push(notification.id);
		});
		dispatch(updateNotificationsByCompanyId(readNotifications));
		handleClose();
	};

	return (
		<Box
			sx={{
				width: '320px',
				display: notifications.length ? 'block' : 'flex',
				flexDirection: notifications.length ? 'unset' : 'column',
				justifyContent: notifications.length ? 'unset' : 'center',
			}}
		>
			<Stack spacing={1}>
				{notifications.length ? (
					<>
						<NotificationsBoxHeader handleMarkAsRead={handleMarkAsRead} unreadAmount={unreadAmount} />
						<Box sx={{ maxHeight: '380px', overflowY: 'scroll', overflowX: 'hidden' }}>
							{notifications.map((notification, index) => {
								return (
									<NotificationItem
										handleClose={handleClose}
										key={index}
										notification={notification}
									/>
								);
							})}
						</Box>
					</>
				) : (
					<EmptyNotifications />
				)}
			</Stack>
		</Box>
	);
}
